"use strict";

var QUALTIY_RATING = {
	DISCONNECTED: 0,
	REALLY_BAD: 1,
	BAD: 2,
	MEDIOCRE: 3,
	GOOD: 4,
	PERFECT: 5
};

module.exports = {
	analyzeStats: analyzeStats,
	QUALTIY_RATING: QUALTIY_RATING
};

var DATA_TYPES = [
	"transport",
	"ssrc",
	"inbound-rtp",
	"inboundrtp",
	"remote-inbound-rtp"
];

function analyzeStats(stats) {
	var hasData = false;

	if(typeof stats[0] === "string") {
		try {
			stats = JSON.parse(stats[0]);
		} catch(e) {
			stats = [];
		}
	}

	stats.forEach(function(stat) {
		if(DATA_TYPES.indexOf(stat.type) !== -1) {
			hasData = true;
		}
		console.log(stat);
	});

	var quality = getQualityLevel(stats);

	return {
		hasData: hasData,
		quality: quality
	};
}

// Based on https://www.callstats.io/blog/2015/07/06/basics-webrtc-getstats-api
function getQualityLevel(stats) {
	var rttValues = [];

	stats.forEach(function(stat) {
		if(stat.type === "outboundrtp" || stat.type === "remote-inbound-rtp") {
			// Modern WebRTC API in Chrome and Firefox
			rttValues.push(stat.roundTripTime);
		} else if(stat.type === "ssrc") {
			if(stat.values) {
				// React Native WebRTC API, legacy Google stats
				stat.values.forEach(function(value) {
					if(value.googRtt) rttValues.push(value.googRtt);
				});
			} else {
				if(stat.googRtt) {
					rttValues.push(stat.googRtt);
				}
			}
		}
	});

	if (!rttValues.length) return QUALTIY_RATING.DISCONNECTED;

	var averageRTT = average(rttValues);

	if (averageRTT / 2 >= 500)
		return QUALTIY_RATING.REALLY_BAD;
	else if (averageRTT / 2 >= 400)
		return QUALTIY_RATING.BAD;
	else if (averageRTT / 2 >= 300)
		return QUALTIY_RATING.MEDIOCRE;
	else if (averageRTT / 2 >= 200)
		return QUALTIY_RATING.GOOD;
	else if (averageRTT / 2 < 200)
		return QUALTIY_RATING.PERFECT;
}

function average(values) {
	var sumValues = values.reduce(function (sum, value) {
		return sum + value;
	}, 0);
	return (sumValues / values.length);
}